if (!customElements.get('kivo-home-product-01')) {
  customElements.define(
    'kivo-home-product-01',
    class KivoHomeProduct01 extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.swatches = Array.from(this.querySelectorAll('[data-kivo-home-product-01-swatch]'));
        this.variantInput = this.querySelector('[data-kivo-home-product-01-variant-input]');
        this.addButton = this.querySelector('[data-kivo-home-product-01-add]');
        this.priceNodes = Array.from(this.querySelectorAll('[data-kivo-home-product-01-price]'));

        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => this.selectSwatch(swatch));
        });

        const activeSwatch = this.swatches.find((swatch) => swatch.classList.contains('is-active'));
        if (activeSwatch) this.selectSwatch(activeSwatch);
      }

      selectSwatch(activeSwatch) {
        this.swatches.forEach((swatch) => {
          const isActive = swatch === activeSwatch;
          swatch.classList.toggle('is-active', isActive);
          swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const isAvailable = activeSwatch.dataset.variantAvailable === 'true';

        if (this.variantInput && activeSwatch.dataset.variantId) {
          this.variantInput.value = activeSwatch.dataset.variantId;
          this.variantInput.toggleAttribute('disabled', !isAvailable);
        }

        if (this.addButton) {
          this.addButton.toggleAttribute('disabled', !isAvailable);
          this.addButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
          this.addButton.querySelectorAll('[data-kivo-home-product-01-add-label]').forEach((label) => {
            label.textContent = isAvailable ? label.dataset.availableLabel : this.addButton.dataset.soldOutLabel;
          });
        }

        if (activeSwatch.dataset.variantPrice) {
          this.priceNodes.forEach((priceNode) => {
            priceNode.textContent = activeSwatch.dataset.variantPrice;
          });
        }
      }
    }
  );
}
